import { TextField, Autocomplete } from "@mui/material";
import type { SyntheticEvent } from "react";
import type { KeyValueOption, KeySelectChangedHandler } from "./types";

const reasonsClosing: KeyValueOption[] = [
  { key: 1, value: "停電" },
  { key: 2, value: "浸水・冠水" },
  { key: 3, value: "設備被害" },
  { key: 4, value: "人員被害" },
  { key: 5, value: "油切れ" },
  { key: 6, value: "計画休業" },
];

type ReasonsClosinCategorySelectProps = {
  reasonsClosinCategory?: number | string | null;
  changedValue: KeySelectChangedHandler;
};

export default function ReasonsClosinCategorySelect({
  reasonsClosinCategory,
  changedValue,
}: ReasonsClosinCategorySelectProps) {
  const handleChange = (
    _event: SyntheticEvent,
    newValues: KeyValueOption | null,
  ) => {
    changedValue(newValues ? newValues.key : null);
  };

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={reasonsClosing}
      getOptionLabel={(sale) => sale.value}
      isOptionEqualToValue={(option, value) => option.key === value.key}
      value={
        reasonsClosing.find(
          (status) => status.key === reasonsClosinCategory,
        ) || null
      }
      renderInput={(params) => (
        <TextField {...params} placeholder="主たる休業理由選択" />
      )}
      onChange={handleChange}
    />
  );
}
